<div class="flyout-goals-component">
  <div class="flyout-data-group">
    <mat-expansion-panel [expanded]="!expandedTab || expandedTab === 'goals'" class="mat-elevation-z0">
      <mat-expansion-panel-header [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
        <img class="header-icon" src="/assets/img/icons_fl/medal_black.svg" width="30px" height="30px" />
        <span>{{ "flyout.goals.title" | translate }}</span>
      </mat-expansion-panel-header>

      <div class="expansion-panel-row header">
        <div class="label name" (click)="sortByProperty('id')">
          <span class="clickable">{{ "flyout.name" | translate }}</span>
          @if (sortingProperty === "goalName") {
            <span class="sorting-icon-item clickable">
              @if (sortingDirection === 1) {
                <mat-icon>arrow_drop_up</mat-icon>
              }
              @if (sortingDirection === -1) {
                <mat-icon>arrow_drop_down</mat-icon>
              }
            </span>
          }
        </div>
        <div class="label date" (click)="sortByProperty('time')">
          <span class="clickable">{{ "flyout.last-achieved" | translate }}</span>
          @if (sortingProperty === "time") {
            <span class="sorting-icon-item clickable">
              @if (sortingDirection === 1) {
                <mat-icon>arrow_drop_up</mat-icon>
              }
              @if (sortingDirection === -1) {
                <mat-icon>arrow_drop_down</mat-icon>
              }
            </span>
          }
        </div>
        <div class="label value-label" (click)="sortByProperty('count')">
          <span class="clickable">{{ "flyout.count" | translate }}</span>
          @if (sortingProperty === "count") {
            <span class="sorting-icon-item clickable">
              @if (sortingDirection === 1) {
                <mat-icon>arrow_drop_up</mat-icon>
              }
              @if (sortingDirection === -1) {
                <mat-icon>arrow_drop_down</mat-icon>
              }
            </span>
          }
        </div>
      </div>

      @for (entry of entriesToShow; track entry) {
        <div class="expansion-panel-row values">
          <div class="value name">
            <div class="icon">
              <img class="icon-goal" src="/assets/img/medal.svg" />
            </div>
            {{ entry.id }}
          </div>
          <div class="value date">
            <span>{{ entry.time | date: "yyyy-MM-dd HH:mm" }}</span>
          </div>
          <div class="value number">{{ entry.count }}</div>
        </div>
      }
      @if (dataEntries.length > 5) {
        <div class="expansion-panel-row pagination">
          <div class="navigation" (click)="navigateGoals(false)">
            <span>
              <mat-icon>arrow_back</mat-icon>
              {{ "generic.previous" | translate }}
            </span>
          </div>
          <span>{{ spanStart }} - {{ spanEnd }} {{ "generic.of" | translate }} {{ dataEntries.length }}</span>
          <div class="navigation" (click)="navigateGoals(true)">
            <span>
              {{ "generic.next" | translate }}
              <mat-icon>arrow_forward</mat-icon>
            </span>
          </div>
        </div>
      }
    </mat-expansion-panel>
  </div>
</div>
